import { render, staticRenderFns } from "./MenuCardLine.vue?vue&type=template&id=656e8caa&"
import script from "./MenuCardLine.vue?vue&type=script&lang=js&"
export * from "./MenuCardLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports